var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "viq-lens-selector" },
    [
      _vm.lensesLoading
        ? _c(
            "div",
            { staticClass: "viq-lens-selector__loading" },
            _vm._l(3, function (i) {
              return _c("div", {
                key: i,
                staticClass: "viq-lens-selector__skeleton",
              })
            }),
            0
          )
        : [
            _vm.activeLens
              ? _c("div", { staticClass: "viq-lens-selector__clear" }, [
                  _c(
                    "button",
                    {
                      staticClass: "viq-lens-selector__clear-btn",
                      on: { click: _vm.clearLens },
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "10",
                            height: "10",
                            viewBox: "0 0 10 10",
                            fill: "none",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M2 2l6 6M8 2l-6 6",
                              stroke: "currentColor",
                              "stroke-width": "1.2",
                              "stroke-linecap": "round",
                            },
                          }),
                        ]
                      ),
                      _vm._v("\n        Clear lens\n      "),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "viq-lens-selector__group" },
              [
                _c("div", { staticClass: "viq-lens-selector__group-header" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "viq-lens-selector__group-icon",
                      attrs: {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                      },
                    },
                    [
                      _c("rect", {
                        attrs: {
                          x: "1",
                          y: "1",
                          width: "10",
                          height: "3",
                          rx: "1",
                          fill: "currentColor",
                          opacity: "0.6",
                        },
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "1",
                          y: "5.5",
                          width: "10",
                          height: "3",
                          rx: "1",
                          fill: "currentColor",
                          opacity: "0.4",
                        },
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          x: "1",
                          y: "8",
                          width: "10",
                          height: "3",
                          rx: "1",
                          fill: "currentColor",
                          opacity: "0.2",
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "viq-lens-selector__group-label" },
                    [_vm._v("VIXIO LENSES")]
                  ),
                ]),
                _vm._v(" "),
                _vm._l(_vm.templateLenses, function (tpl) {
                  return _c(
                    "div",
                    {
                      key: tpl.id,
                      staticClass: "viq-lens-selector__item",
                      class: {
                        "viq-lens-selector__item--active":
                          _vm.activeLens && _vm.activeLens.id === tpl.id,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.selectLens(tpl)
                        },
                      },
                    },
                    [
                      _c("ViqLensIcon", {
                        staticClass: "viq-lens-selector__item-icon",
                        attrs: { value: tpl.emoji || tpl.id, size: 16 },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "viq-lens-selector__item-info" },
                        [
                          _c(
                            "span",
                            { staticClass: "viq-lens-selector__item-name" },
                            [_vm._v(_vm._s(tpl.name))]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "viq-lens-selector__item-desc" },
                            [_vm._v(_vm._s(tpl.description))]
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "viq-lens-selector__group" },
              [
                _vm._m(0),
                _vm._v(" "),
                _vm.userLenses.length > 0
                  ? _vm._l(_vm.userLenses, function (lens) {
                      return _c(
                        "div",
                        {
                          key: lens.id,
                          staticClass: "viq-lens-selector__item",
                          class: {
                            "viq-lens-selector__item--active":
                              _vm.activeLens && _vm.activeLens.id === lens.id,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.selectLens(lens)
                            },
                          },
                        },
                        [
                          _c("ViqLensIcon", {
                            staticClass: "viq-lens-selector__item-icon",
                            attrs: { value: lens.emoji || lens.id, size: 16 },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "viq-lens-selector__item-info" },
                            [
                              _c(
                                "span",
                                { staticClass: "viq-lens-selector__item-name" },
                                [_vm._v(_vm._s(lens.name))]
                              ),
                              _vm._v(" "),
                              lens.description
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "viq-lens-selector__item-desc",
                                    },
                                    [_vm._v(_vm._s(lens.description))]
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "viq-lens-selector__delete",
                              attrs: { title: "Delete lens" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.deleteLens(lens.id)
                                },
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "10",
                                    height: "10",
                                    viewBox: "0 0 10 10",
                                    fill: "none",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M2 2l6 6M8 2l-6 6",
                                      stroke: "currentColor",
                                      "stroke-width": "1.2",
                                      "stroke-linecap": "round",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    })
                  : _c("div", { staticClass: "viq-lens-selector__empty" }, [
                      _vm._v("\n        No custom lenses yet\n      "),
                    ]),
                _vm._v(" "),
                _vm.mode !== "lens-build"
                  ? _c(
                      "button",
                      {
                        staticClass: "viq-lens-selector__create-btn",
                        on: { click: _vm.openLensBuilder },
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "12",
                              height: "12",
                              viewBox: "0 0 12 12",
                              fill: "none",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M6 1v10M1 6h10",
                                stroke: "currentColor",
                                "stroke-width": "1.2",
                                "stroke-linecap": "round",
                              },
                            }),
                          ]
                        ),
                        _vm._v("\n        Create custom lens\n      "),
                      ]
                    )
                  : _vm._e(),
              ],
              2
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "viq-lens-selector__group-header" }, [
      _c("span", { staticClass: "viq-lens-selector__group-label" }, [
        _vm._v("MY LENSES"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }